import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=66478ed6&"
import script from "./Money.vue?vue&type=script&lang=js&"
export * from "./Money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports